/**
 * The static config compiled into the package. Used whenever the fetch fails, times out,
 * or has not resolved yet, so the bar reserves its final 56px from first paint and never
 * renders blank.
 *
 * It carries the WHOLE catalog, not just the enabled entries, and that is load-bearing
 * rather than tidiness. A host's own `activeAppId` entry is always rendered and indicated,
 * resolved from this list when the payload omits it — so a satellite whose id is missing
 * here loses its chip entirely during an endpoint outage, and with it any indication of
 * where the user is and anything for NavTrigger to dock. Every app that can mount the bar
 * needs an entry, whether or not it is currently switched on.
 *
 * `enabled` here still governs what renders: the same enabled-and-has-destination filter
 * runs against this list as against the fetched payload, so a disabled entry contributes
 * its label, icon, order and destination without appearing as a tile.
 *
 * It carries no look and no wordmark. Colour, layout and the wordmark are compiled in
 * (index.css and nav-bar.tsx), so there is nothing for a fetched payload to disagree with
 * and nothing to flash between first paint and the fetch landing. The catalog is the one
 * field that can still differ — which is why the last good payload is persisted; see
 * storage.ts.
 *
 * These are the production domains, which is why they can live in compiled code at all.
 * Changing this list requires a package release, so it is deliberately the stable
 * first-party set — anything situational (a stage host, a locally-run satellite) belongs
 * in the config row, where an admin can edit it without a release. The row wins whenever the
 * endpoint is reachable, but this list is all a first-ever visit, an outage first-visit, and
 * any session whose API does not serve `/rest/nav-config` ever sees — so a stale href here
 * is a dead link for them. Refresh the hrefs and `enabled` states from the live production
 * payload on each release.
 */
const FALLBACK_CONFIG = {
    schema_version: 1,
    apps: [
        { id: 'home', label: 'Home', icon: 'house', href: 'https://www.arthelper.com/community', enabled: true },
        { id: 'the-daily', label: 'The Daily', icon: 'sunrise', href: 'https://thedaily.arthelper.com', enabled: false },
        {
            id: 'art-review',
            label: 'Art Review',
            icon: 'star',
            href: 'https://artreview.arthelper.com/reports',
            enabled: true,
        },
        {
            id: 'creative-sparks',
            label: 'Creative Sparks',
            icon: 'sparkles',
            href: 'https://sparks.arthelper.com',
            enabled: true,
        },
        { id: 'mockups', label: 'Mockups', icon: 'frame', href: 'https://mockups.arthelper.com', enabled: true },
        {
            id: 'art-books',
            label: 'Art Books',
            icon: 'book-open',
            href: 'https://artbooks.arthelper.com/books',
            enabled: true,
        },
        {
            id: 'social-posting',
            label: 'Social Autoposter',
            icon: 'megaphone',
            href: 'https://autoposter.arthelper.com',
            enabled: true,
        },
        {
            id: 'playbooks',
            label: 'Playbooks',
            icon: 'clipboard-list',
            href: 'https://playbooks.arthelper.com',
            enabled: true,
        },
        {
            id: 'art-madness',
            label: 'Art Madness',
            icon: 'trophy',
            href: 'https://art-madness.arthelper.com',
            enabled: true,
        },
        {
            id: 'galleries',
            label: 'Galleries',
            icon: 'images',
            href: 'https://galleries.arthelper.com/galleries',
            enabled: true,
        },
    ],
};
export { FALLBACK_CONFIG };
//# sourceMappingURL=fallback.js.map